// src/components/about/StrategicSDGsSection.js
import React from 'react';
import { motion } from 'framer-motion';
import Section from '../common/Section';
import Heading from '../common/Heading';

const StrategicSDGsSection = () => {
  // SDG data
  const sdgs = [
    {
      number: 1,
      title: 'No Poverty',
      color: '#E5243B',
      icon: '/images/sdgs/sdg-1.png',
      description: 'Our "Skills Against Poverty" motto drives our mission to equip youth with marketable skills that lead to economic independence and poverty reduction.'
    },
    {
      number: 4,
      title: 'Quality Education',
      color: '#C5192D',
      icon: '/images/sdgs/sdg-4.png',
      description: 'We provide accessible, high-quality technical education that bridges the gap between theoretical knowledge and practical skills needed in today\'s job market.'
    },
    {
      number: 7,
      title: 'Affordable and Clean Energy',
      color: '#FCC30B',
      icon: '/images/sdgs/sdg-7.png',
      description: 'Our training programs incorporate sustainable energy practices and green skills to prepare youth for the growing renewable energy sector.'
    },
    {
      number: 8,
      title: 'Decent Work and Economic Growth',
      color: '#A21942',
      icon: '/images/sdgs/sdg-8.png',
      description: 'By enhancing employability and entrepreneurship capabilities, we contribute to economic growth and create pathways to decent work for Sierra Leonean youth.'
    },
    {
      number: 13,
      title: 'Climate Action',
      color: '#3F7E44',
      icon: '/images/sdgs/sdg-13.png',
      description: 'We integrate climate-conscious approaches into our training, preparing the next generation of engineers and technologists to address climate challenges.'
    }
  ];

  // Animation variants for container
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  // Animation variants for items
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <Section background="white" padding="lg" id="sdgs-section">
      <div className="text-center mb-12">
        <Heading level={2} align="center" className="mb-4" withAccent>
          Our Target SDGs
        </Heading>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          Our work aligns with and contributes to the United Nations Sustainable Development Goals,
          with strategic focus on these five key areas:
        </p>
      </div>

      {/* SDGs display - single row on desktop, responsive on mobile */}
      <motion.div 
        className="flex flex-wrap justify-center"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-50px" }}
      >
        {sdgs.map((sdg) => (
          <motion.div
            key={sdg.number}
            className="w-full sm:w-1/2 md:w-1/3 lg:w-1/5 p-3"
            variants={itemVariants}
          >
            <div className="flex flex-col items-center">
              {/* SDG Icon/Image */}
              <div 
                className="w-full aspect-square max-w-xs rounded-lg shadow-md overflow-hidden mb-4"
                style={{ backgroundColor: sdg.color }}
              >
                <img 
                  src={sdg.icon}
                  alt={`SDG ${sdg.number}: ${sdg.title}`}
                  className="w-full h-full object-contain"
                  onError={(e) => {
                    e.target.onerror = null;
                    // Fallback to colored block with text if image fails to load
                    e.target.parentElement.innerHTML = `
                      <div class="w-full h-full flex items-center justify-center text-white p-4 text-center">
                        <div>
                          <div class="text-5xl font-bold mb-2">${sdg.number}</div>
                          <div class="text-xl font-bold uppercase">${sdg.title}</div>
                        </div>
                      </div>
                    `;
                  }}
                />
              </div>
        
            </div>
          </motion.div>
        ))}
      </motion.div>

      
    </Section>
  );
};

export default StrategicSDGsSection;